import { useRef, useState } from 'react';

const usePagination = (initialPage = 0, initialPageSize = 9) => {
    const tokens = useRef([null]);
    const pageToken = useRef(null);
    const [count, setCount] = useState(0);
    const rowsPerPageOptions = [9, 10, 15, 20, 25, 30, 35, 40, 45, 50];
    const [paginationModel, setPaginationModel] = useState({
        page: initialPage,
        pageSize: initialPageSize
    });

    const parseHeader = (header) => ({
        paginationToken: header['pagination-token'] || null,
        paginationCount: parseInt(header['pagination-count'] || '0', 10)
    });

    const resolveHeader = (headers, page = 0) => {
        const { paginationToken, paginationCount } = parseHeader(headers);
        pageToken.current = paginationToken;
        tokens.current[page + 1] = paginationToken;
        setCount(paginationCount);
    };

    const currentToken = (page) =>
        page < tokens.current.length && page >= 0 ? tokens.current[page] : null;

    return {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    };
};

export default usePagination;
